var React = require('react');

function Group (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M18 14a3 3 0 110-6 3 3 0 010 6zm-9-3a4 4 0 110-8 4 4 0 010 8z","fill":"#335EEA","opacity":".3","key":1}),React.createElement("path",{"d":"M17.601 15c3.407.038 6.188 1.76 6.397 5.4.009.147 0 .6-.542.6H19.6c0-2.25-.744-4.328-1.999-6zm-17.6 5.2C.388 15.426 4.26 13 8.983 13c4.788 0 8.722 2.293 9.015 7.2.012.195 0 .8-.751.8H.727c-.25 0-.747-.54-.726-.8z","fill":"#335EEA","key":2})]));
}

Group.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Group;

Group.default = Group;
